module.exports = __webpack_public_path__ + "img/title-02.ddcf19a3.png";